'use strict';
module.exports = require('../../full/object/keys');



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/features/object/keys.js
// module id = 344
// module chunks = 0